export default {
  components: [
    {
      data: [
        {
          type: "",
          id: "",
          imageUrl: "",
          redirectUrl: "",
          newTab: "",
          altText: "",
          direction: "",
        },
        {
          type: "footer-notes",
          id: "",
          imageUrl: "",
          redirectUrl: "",
          newTab: "",
          altText: "",
          direction: "",
        }
      ]
    }
  ],
  footerNotes: [
    {
      data: [
        {
          content: "© 2025 AirAsia Berhad. This website is owned and operated by Move Travel Sdn Bhd (formerly known as AirAsia Com Travel Sdn Bhd) (201301020508), a registered travel agency (KPK/LN License No: 8287). Your usage of this website indicates that you agree to be bound by our {0}, {1} and {2}.",
          id: "footerTopLinks",
        },
        {
          content: "© 2025 AirAsia Berhad (Malaysia)。本网站由注册旅行机构(KPK/LN证书号: 8287)-AMove Travel Sdn Bhd (formerly known as AirAsia Com Travel Sdn Bhd) (201301020508), 所有并运营。使用本网站即代表您同意遵守我们的 {0}、{1} 及 {2}。{3} {4} {5}",
          id: "footerTopLinks2",
        },
        {
          content: "{0} | {1} | {2} | {3} | {4} ",
          id: "footerBottomLinks",
        },
      ]
    }
  ],
  footerTopLinks: [
    {
      data: [
        {
          label: "Terms and Conditions",
          url: "https://www.airasia.com/aa/about-us/en/gb/terms-and-conditions.html",
          cnUrl: "https://www.airasia.com/aa/about-us/en/gb/terms-and-conditions.html",
          newTab: "TRUE",
        },
        {
          label: "Terms of Use",
          url: "https://www.airasia.com/aa/about-us/en/gb/terms-of-use.html",
          cnUrl: "https://www.airasia.com/aa/about-us/en/gb/terms-of-use-cn.html",
          newTab: "TRUE",
        },
        {
          label: "Privacy Statement",
          url: "https://www.airasia.com/aa/about-us/en/gb/privacy-statement.html",
          cnUrl: "https://www.airasia.com/aa/about-us/en/gb/privacy-statement-cn.html",
          newTab: "TRUE",
        },
      ]
    }
  ],
    footerTopLinks2: [
      {
        data: [
          {
            label: "条款与条件",
            url: "https://www.airasia.com/aa/about-us/zh/cn/terms-and-conditions.html",
            cnUrl: "https://www.airasia.com/aa/about-us/zh/cn/terms-and-conditions.html",
            newTab: "TRUE",
          },
          {
            label: "使用条款",
            url: "https://www.airasia.com/aa/about-us/zh/cn/terms-of-use.html",
            cnUrl: "https://www.airasia.com/aa/about-us/zh/cn/terms-of-use.html",
            newTab: "TRUE",
          },
          {
            label: "隐私声明",
            url: "https://www.airasia.com/aa/about-us/zh/cn/privacy-statement-cn.html",
            cnUrl: "https://www.airasia.com/aa/about-us/zh/cn/privacy-statement-cn.html",
            newTab: "TRUE",
          },
          {
            label: "亚航易站商务信息咨询（广州）有限公司",
            url: "https://www.airasia.cn/zh/cn",
            cnUrl: "https://www.airasia.cn/zh/cn",
            newTab: "TRUE",
          },
          {
            label: "粤ICP备17160544号-2",
            url: "https://beian.miit.gov.cn/#/Integrated/recordQuery",
            cnUrl: "https://beian.miit.gov.cn/#/Integrated/recordQuery",
            newTab: "TRUE",
          },
          {
            label: "证照信息",
            url: "https://assets.contentstack.io/v3/assets/blt63d664cad6b81036/blt6875d8153a4624a1/6551c75b829051a8ad2c813f/AAcom_New_Business_License%E8%90%A5%E4%B8%9A%E6%89%A7%E7%85%A7%E5%89%AF%E6%9C%AC.pdf",
            cnUrl: "https://assets.contentstack.io/v3/assets/blt63d664cad6b81036/blt6875d8153a4624a1/6551c75b829051a8ad2c813f/AAcom_New_Business_License%E8%90%A5%E4%B8%9A%E6%89%A7%E7%85%A7%E5%89%AF%E6%9C%AC.pdf",
            newTab: "TRUE",
          },
        ]
      }
    ],
  footerBottomLinks: [
    {
      data: [
        {
          label: "AirAsia Berhad (Malaysia)",
          url: "https://ir.airasia.com/corporate_structure.html",
          cnUrl: "",
          newTab: "TRUE",
        },
        {
          label: "Thai AirAsia Co. Ltd (泰国亚洲航空)",
          url: "https://www.aavplc.com/en/thai-airasia-taa/organisation-structure",
          cnUrl: "",
          newTab: "TRUE",
        },
        {
          label: "PT Indonesia AirAsia (印尼亚洲航空)",
          url: "https://www.airasia.com/aa/about-us/en/gb/airasia-indonesia-organizational-structure.html",
          cnUrl: "",
          newTab: "TRUE",
        },
        {
          label: "Philippines AirAsia Inc. (菲律宾亚洲航空)",
          url: "https://www.airasia.com/aa/about-us/en/gb/airasia-philippine-organizational-structure.html",
          cnUrl: "",
          newTab: "TRUE",
        },
        {
          label: "AirAsia (India) Limited",
          url: "https://www.airasia.com/aa/about-us/en/gb/airasia-india-organizational-structure.html",
          cnUrl: "",
          newTab: "TRUE",
        },
      ]
    }
  ],
}